/**
 * The season the circle is choosing a face FOR — the next one, northern
 * hemisphere. In September that is Winter, not Fall: the hero said "Fall 2026"
 * in a literal while every other label on the page computed the right season.
 */
export function upcomingSeason (date = new Date()) {
  const m = date.getMonth(); const y = date.getFullYear()
  if (m >= 2 && m <= 4) return `Summer ${y}`     // spring → next summer
  if (m >= 5 && m <= 7) return `Fall ${y}`        // summer → next fall
  if (m >= 8 && m <= 10) return `Winter ${y}`     // fall → next winter
  return `Spring ${m === 11 ? y + 1 : y}`         // winter → next spring
}
